import useAppModernisation from "../../hooks/useAppModernisation";
import App from "../../App";
import ModernApp from "./ModernApp";

const AppRouter = () => {
  const { isAppMode, isWebModernisationEnabled } = useAppModernisation();

  if (isAppMode) {
    return <App />
  } else if (isWebModernisationEnabled) {
    return <ModernApp />;
  }
  return <App />
};

export default AppRouter;